import { RouteAuthenticationRequirement, RouteItem } from '@cksoftware/react-base';
import { AppRoles } from '../constants/appRoles.ts';
import { ApplicationRoutes } from '../constants/appRoutes.ts';
import { Layout } from '../components/layout/layout.tsx';

export const ManagePurebredBuyersRoutes: RouteItem = {
  text: 'Manage Purebred Buyers',
  authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
  allowedRoles: [AppRoles.Admin],
  path: ApplicationRoutes.admin.buyerApproval,
  layout: <Layout />,
  async lazy() {
    const component = await import('../features/buyerApproval/admin/BuyerApprovalAdmin');
    return { Component: component.BuyerApprovalAdmin };
  }
};
